"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _helpers = require("../helpers");

var _containers = require("../containers");

var _CharacteristicsFilters = _interopRequireDefault(require("../components/CampaignCreator/CharacteristicsFilters"));

var _PlaceholderMetrics = _interopRequireDefault(require("../components/CampaignCreator/PlaceholderMetrics"));

var _MetricsFilters = _interopRequireDefault(require("../components/CampaignCreator/MetricsFilters"));

var _Sidebar = _interopRequireDefault(require("../components/CampaignCreator/Sidebar"));

var _DataCaveats = _interopRequireDefault(require("../components/DataCaveats"));

var _ResetButton = _interopRequireDefault(require("./ResetButton"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FindPersonas = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FindPersonas, _React$Component);

  function FindPersonas() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      communityColours: {},
      showSidebar: false,
      showMeasure: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleHideUnselectedPersonas", function () {
      _this.props.toggleSegmentSelectionVisibility(!_this.props.hideUnselectedPersonas);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      _this.setState(_extends({}, _this.state, {
        showSidebar: !_this.state.showSidebar
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "clearForm", function () {
      _this.props.resetDataPage();

      _this.props.toggleSegmentSelectionVisibility(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMeasureSideBarTabChange", function (event, data) {
      _this.setState(_extends({}, _this.state, {
        showMeasure: data.activeIndex === 0 ? true : false // individual persona tab is on index 1

      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectPersona", function (id, label) {
      var personaObj = {
        id: parseInt(id),
        name: label
      };
      _this.props.findPersonasSelected.length ? _this.props.findPersonasSelected.filter(function (persona) {
        return persona.id === id;
      }).length ? _this.props.removeSelectedPersona(personaObj) : _this.props.addSelectedPersona(personaObj) : _this.props.addSelectedPersona(personaObj);
    });

    return _this;
  }

  var _proto = FindPersonas.prototype;

  _proto.componentDidMount = /*#__PURE__*/function () {
    var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this$props, isDataPage, loadSuperSegments, loadCharacteristics, featureAccess, resetDataPage, superSegments;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, isDataPage = _this$props.isDataPage, loadSuperSegments = _this$props.loadSuperSegments, loadCharacteristics = _this$props.loadCharacteristics, featureAccess = _this$props.featureAccess, resetDataPage = _this$props.resetDataPage;

              if (isDataPage) {
                resetDataPage(); // Clear page state if it's a data page
              }

              _context.next = 4;
              return loadSuperSegments();

            case 4:
              superSegments = _context.sent;
              this.setState({
                communityColours: (0, _helpers.getSuperSegmentColours)(superSegments)
              });
              loadCharacteristics();
              featureAccess();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentDidMount() {
      return _componentDidMount.apply(this, arguments);
    }

    return componentDidMount;
  }();

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        characteristics = _this$props2.characteristics,
        isDataPage = _this$props2.isDataPage,
        hasAccess = _this$props2.hasAccess,
        selectedMeasure = _this$props2.selectedMeasure,
        updateSelectedMeasure = _this$props2.updateSelectedMeasure,
        hideUnselectedPersonas = _this$props2.hideUnselectedPersonas;
    var _this$state = this.state,
        showSidebar = _this$state.showSidebar,
        communityColours = _this$state.communityColours;
    var tabProps = {
      hideUnselectedPersonas: hideUnselectedPersonas,
      handleHideUnselectedPersonas: this.handleHideUnselectedPersonas,
      communityColours: communityColours,
      handleSelectPersona: this.handleSelectPersona,
      isDataPage: isDataPage
    };
    var panesTable = [{
      menuItem: 'Individual Attributes',
      render: function render() {
        return /*#__PURE__*/React.createElement(_containers.IndividualTab, tabProps);
      }
    }, {
      menuItem: 'Combined Attributes',
      render: function render() {
        return /*#__PURE__*/React.createElement(_containers.GroupedTab, tabProps);
      }
    }];

    var Title = function Title() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Icon, {
        className: "grouped-personas__icon",
        name: "bars",
        size: "large",
        onClick: _this2.toggleSidebar
      }), /*#__PURE__*/React.createElement("h2", {
        className: "grouped-personas__sub-title"
      }, "Selection"), isDataPage && /*#__PURE__*/React.createElement(_ResetButton["default"], {
        resetMethod: _this2.clearForm
      }));
    };

    return /*#__PURE__*/React.createElement("div", null, hasAccess ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "campaign-creator-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__row"
    }, /*#__PURE__*/React.createElement(_Sidebar["default"], {
      open: showSidebar,
      title: /*#__PURE__*/React.createElement(Title, null),
      body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_MetricsFilters["default"], {
        showMeasure: this.state.showMeasure,
        selectedMeasure: selectedMeasure,
        updateSelectedMeasure: updateSelectedMeasure
      }), /*#__PURE__*/React.createElement("div", {
        className: "characteristics-filter--wrapper"
      }, /*#__PURE__*/React.createElement(_CharacteristicsFilters["default"], {
        className: "scroll-box",
        characteristics: characteristics
      }), process.env.REACT_APP_DATA_ENDPOINT === 'premium' && /*#__PURE__*/React.createElement(_PlaceholderMetrics["default"], null)))
    }), /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__table"
    }, isDataPage ? /*#__PURE__*/React.createElement(_containers.IndividualTab, tabProps) : /*#__PURE__*/React.createElement(_semanticUiReact.Tab, {
      className: "tabs tabs--short",
      onTabChange: this.handleMeasureSideBarTabChange,
      panes: panesTable
    }))), /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__row"
    }, /*#__PURE__*/React.createElement(_DataCaveats["default"], {
      showDownload: true
    })))) : '');
  };

  return FindPersonas;
}(React.Component);

exports["default"] = FindPersonas;